import { proxy } from 'valtio'
import { fetchRconStats } from '../../api/rconStatsApi'

export const UTOPIA_PLAY_LABEL_BROWSER = 'Jouer dans le navigateur'
export const UTOPIA_PLAY_LABEL_ACCOUNT = 'Jouer avec ce compte'
export const UTOPIA_PLAY_LABEL_OFFLINE = 'Serveur hors ligne'
const POLL_MS = 10_000

export const utopiaServerStatusState = proxy({
  online: null as boolean | null,
  loading: false,
  checked: false,
  error: null as string | null,
})

export function getUtopiaPlayButtonState (variant: 'browser' | 'account') {
  const { online, checked } = utopiaServerStatusState
  const defaultLabel = variant === 'account' ? UTOPIA_PLAY_LABEL_ACCOUNT : UTOPIA_PLAY_LABEL_BROWSER

  if (checked && online === false) {
    return { disabled: true, label: UTOPIA_PLAY_LABEL_OFFLINE }
  }
  return { disabled: false, label: defaultLabel }
}

export async function refreshUtopiaServerStatus (signal?: AbortSignal) {
  utopiaServerStatusState.loading = true
  const data = await fetchRconStats(signal)
  if (signal?.aborted) return
  utopiaServerStatusState.online = data?.online === true
  utopiaServerStatusState.error = data?.error ?? null
  utopiaServerStatusState.checked = true
  utopiaServerStatusState.loading = false
}

let pollStarted = false

/** Polling RCON partagé (accueil, menu compte, page rejoindre). */
export function startUtopiaServerStatusPolling () {
  if (pollStarted) return
  pollStarted = true

  const tick = (signal?: AbortSignal) => {
    void refreshUtopiaServerStatus(signal)
  }

  tick()
  const interval = setInterval(() => tick(), POLL_MS)

  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => clearInterval(interval))
  }
}
